import PlusIcon from 'assets/icons/plus';
import MasterClaimsTable from 'components/features/master-claims-table';
import CustomButton from 'components/ui/custom-button';
import { EButtonVariant } from 'components/ui/custom-button/enums';
import { ENavigationPath } from 'constants/path';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const MasterClaimsDashboard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <div>
        <div className="flex justify-end">
          <CustomButton
            variant={EButtonVariant.PRIMARY}
            label={t('masterClaims.createNewClaim')}
            prefixIcon={<PlusIcon color="#fff" />}
            onClick={() => navigate(ENavigationPath.REGISTER_NEW_MASTER_CLAIM)}
            className="mt-0 px-4"
          />
        </div>
        <div className="bg-[#E3F2FB] p-[10px] rounded-lg my-[20px]">
          <MasterClaimsTable />
        </div>
      </div>
    </>
  );
};

export default MasterClaimsDashboard;
